import React, { useCallback, useMemo, useState } from 'react'
import InlineGroup from '../../../atoms/inlinegroup/InlineGroup'
import VerticalGroup from '../../../atoms/verticalgroup/VerticalGroup'
import SimulationSetting from '../edit/SimutationSetting'
import Text from '../../../atoms/text/Text'
// import { capitalize } from '../../../../services/utils'
import Button from '../../../atoms/button/Button'
import PreviewModal from './EventSchedulingPreviewModal'
import EventSchedulingForm from './EventSchedulingForm'
import { fullDateAndTime } from '../../../../lib/date'

interface EventSchedulingSummaryProps {
  readOnly?: boolean
  schedule?: API.EventSchedule
  simulation?: API.SimulationResponse
  onSave?: (value: API.EventSchedule) => void
}

const EventSchedulingSummary = ({ schedule, simulation, readOnly = false, onSave }: EventSchedulingSummaryProps) => {
  const [shouldShowPreviewModal, setShouldShowPreviewModal] = useState(false)
  const [shouldShowEditModal, setShouldShowEditModal] = useState(false)


  const onPreviewClicked = useCallback(() => {
    setShouldShowPreviewModal(true)
  }, [setShouldShowPreviewModal])

  const onClosePreviewModal = useCallback(() => {
    setShouldShowPreviewModal(false)
  }, [setShouldShowPreviewModal])

  const onEditClicked = useCallback(() => {
    setShouldShowEditModal(true)
  }, [setShouldShowEditModal])

  const onSaveSchedule = useCallback((schedule) => {
    onSave && onSave(schedule)
    setShouldShowEditModal(false)
  }, [onSave])

  const onCloseEditModal = useCallback(() => {
    setShouldShowEditModal(false)
  }, [setShouldShowEditModal])

  const summaryString = useMemo(() => {
    if (!schedule) {
      return ''
    }
    if (schedule.roundType === 'scheduled') {
      return `${schedule.schedules.length - 1} scheduled rounds`
    }
    let durationString = ''
    if (schedule.schedules.every(s => s.timeAllocated === schedule.schedules[0].timeAllocated)) {
      durationString = ` x ${schedule.schedules[0].timeAllocated}min`
    }
    return `${schedule.schedules.length - 1}${durationString} facilitated rounds`
  }, [schedule])

  const getStatus = useCallback(() => {
    if (readOnly && !schedule) return 'noScheduleInView'
    if (!readOnly && !simulation) return 'noSimulationInEdit'
    if (!readOnly && !schedule) return 'noScheduleInEdit'
    return 'ready'
  }, [readOnly, schedule, simulation])
  const status = getStatus()

  return <>
    <SimulationSetting icon='schedule' onTrashClick={() => {}} readOnly warning={status === 'noScheduleInView'}>
      <InlineGroup stretch>
        <VerticalGroup spaceBetweenElements={2}>
          <Text size="sm" bold>Schedule</Text>
          {schedule && <>
            <Text size='sm'>{summaryString}</Text>
            {schedule.roundType === 'scheduled' && <Text size='sm'>{`Round 1 starts at ${fullDateAndTime(schedule.schedules[0].startTime!)}`}</Text>}
          </>}
          {status === 'noScheduleInView' && <Text size="sm" colour='danger' bold>No schedule set</Text>}
          {status === 'noScheduleInEdit' && <Text size="sm">No schedule set</Text>}
          {status === 'noSimulationInEdit' && <Text size="sm" colour='danger' bold>You must select a simulation before you can set a schedule</Text>}
          {['ready', 'noScheduleInEdit'].includes(status)  && <Button data-test="view-event-schedule" link onClick={readOnly ? onPreviewClicked : onEditClicked} style={{ height: 'auto'}}>
            {readOnly ? 'View Schedule' : schedule ? 'Edit Schedule' : 'Create Schedule'}
          </Button>}

        </VerticalGroup>
      </InlineGroup>
    </SimulationSetting>
    {schedule && <PreviewModal
      data-test="preview-schedule-modal"
      isOpen={shouldShowPreviewModal}
      onClose={onClosePreviewModal}
      schedule={schedule}
    />}
    {onSave && shouldShowEditModal && <EventSchedulingForm
      data-test="preview-schedule-modal"
      isOpen={shouldShowEditModal}
      onClose={onCloseEditModal}
      schedule={schedule}
      simulation={simulation}
      onSave={onSaveSchedule}
      onCancel={onCloseEditModal}
    />}
  </>
}

export default EventSchedulingSummary